import * as React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import AspectRatio from "@mui/joy/AspectRatio";
import Card from "@mui/joy/Card";
import CardContent from "@mui/joy/CardContent";
import Chip from "@mui/joy/Chip";
import Typography from "@mui/joy/Typography";
import calendarimg from "../assets/img/calander.png";
import { hackathons } from "../data/portfolioData";

function HackathonCard({ data }) {
  return (
    <Card
      className="hack-card"
      variant="outlined"
      orientation="horizontal"
      color="primary"
      sx={{
        "&:hover": {
          backgroundColor: "#171922",
          borderColor: "rgba(133, 197, 255, 0.75)",
        },
        backgroundColor: "#0b0b0f",
        borderColor: "rgba(120, 190, 255, 0.55)",
        boxShadow: "0 10px 26px rgba(0, 0, 0, 0.35)",
        borderRadius: 16,
        width: { xs: "100%", sm: "100%" },
        maxWidth: { xs: "100%", sm: 420, md: 460, lg: 320 },
        margin: 0,
        alignItems: "center",
        columnGap: { xs: 1, sm: 1.2 },
        transition: "all .25s ease",
        p: { xs: 0.9, sm: 1 },
      }}
    >
      <AspectRatio
        ratio="1"
        sx={{
          width: { xs: 78, sm: 78 },
          minWidth: { xs: 78, sm: 78 },
          borderRadius: 10,
          overflow: "hidden",
          bgcolor: "#12131a",
          border: "1px solid rgba(255,255,255,0.18)",
          my: 0.25,
        }}
      >
        <img
          className="hackimg"
          style={{ objectFit: "contain" }}
          src={data.imgSrc}
          loading="lazy"
          decoding="async"
          alt="hackathonimg"
        />
      </AspectRatio>
      <CardContent sx={{ ml: 1, py: 0.25 }}>
        <Typography
          className="hack-card-title"
          level="title-lg"
          id="card-description"
          sx={{
            color: "white",
            fontSize: 16,
            lineHeight: 1.25,
            mb: 0.15,
            display: "-webkit-box",
            WebkitLineClamp: 2,
            WebkitBoxOrient: "vertical",
            overflow: "hidden",
          }}
        >
          {data.title}
        </Typography>
        <Typography
          className="hack-card-location"
          level="body-sm"
          aria-describedby="card-description"
          sx={{ color: "#8b8d96", mb: 0.25, fontSize: 15 }}
        >
          {data.location}
        </Typography>
        <Typography
          className="hack-card-time"
          level="body-sm"
          aria-describedby="card-description"
          sx={{ color: "#8b8d96", display: "flex", alignItems: "center", mb: 0.45, fontSize: 15 }}
        >
          <img className="calendarimg" src={calendarimg} alt="calendar" loading="lazy" decoding="async" />
          {data.time}
        </Typography>
        <a target="_blank" href={data.hackathonlink} rel="noreferrer">
          <Chip
            className="hack-card-chip"
            variant="outlined"
            color="primary"
            size="sm"
            sx={{
              pointerEvents: "none",
              borderColor: "rgba(142, 205, 255, 0.6)",
              color: "#d8ebff",
              bgcolor: "rgba(142, 205, 255, 0.08)",
            }}
          >
            {data.chipLabel}
          </Chip>
        </a>
      </CardContent>
    </Card>
  );
}



export default function HackathonCardSlider() {
  const settings = {
    dots: false,
    arrows:false,
    infinite: true,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    responsive: [
      {
        breakpoint: 1320,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        }
      },
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        }
      },
      {
        breakpoint: 700,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  };

  return (
    <div className="hack-slider-wrap">
      <Slider {...settings}>
        {hackathons.map((card) => (
          <div key={card.id}>
            <HackathonCard data={card} />
          </div>
        ))}
      </Slider>
    </div>
  );
}
